import React from 'react';
import { useParams } from 'react-router-dom';
import RelativeRedirect from '../../../elements/RelativeRedirect';
import { useSavedTab } from '../tabs';

function EventLeadsDefaultTab(props) {
    const {} = props,
        { eventId } = useParams(),
        savedTab = useSavedTab(eventId);

    return <RelativeRedirect to={['.', savedTab].join('/')} />;
}

export default EventLeadsDefaultTab;
